import React from 'react';
import { MediaItemValue } from '@fulcrumapp/fulcrum-core';
import { PlayIcon } from '../../../icons';
import MediaThumbnail from './media-thumbnail';

type Props = {
  item: MediaItemValue;
  styles: React.CSSProperties;
  handleClick: (e: React.MouseEvent<HTMLDivElement>) => void;
}

const audioStyles = {
  border: '3px solid transparent',
  padding: 8,
  backgroundColor: '#333',
  fill: '#fff',
};

const AudioThumbnail = ({ item, styles, handleClick }: Props) => (
  <MediaThumbnail
    item={item}
    styles={{ ...styles, ...audioStyles }}
    handleClick={handleClick}
    data-testid="audio-thumbnail"
  >
    <PlayIcon data-testid="audio-play-icon" />
  </MediaThumbnail>
);

export default AudioThumbnail;
